<template>
  <div>
    <component :is="$appName" :params="params" :error="error" :edition="edition" />
    <div class="form-row">
      <r-input v-model="params.serial_number" name="n° de série" label="N° de série (référence derrière le produit)" icon="address-card-o" class="col" :error="error.serial_number" />
      <div class="form-group col-sm">
        <label class="access-form__label">Garantie</label>
          <p class="form-control disabled pl-4" v-if="params.guarantee">{{ params.formatted_guarantee }}</p>
          <p class="form-control disabled pl-4 bg-light" v-else>
            <em>Rempli par {{ $appName | capitalize }}</em>
          </p>
      </div>
    </div>
    <div class="form-row">
      <r-input
        v-model="params.purchased_place"
        name="lieu d'achat"
        label="Lieu d'achat"
        icon="map-marker"
        :error="error.purchased_place"
        class="col-8" />
      <zc-input v-model="params.purchased_place_zip_code" :error="error.purchased_place" class="col-4" />
    </div>
    <d-input v-model="params.purchased_at" label="Date d'achat" name="date d'achat" rules="required" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import sps from './product_selection/SpsSelection'
import bestove from './product_selection/BestoveSelection'

export default {
  name: 'Infos',
  components: {
    sps,
    bestove
  },
  props: {
    params: Object,
    error: Object,
    edition: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['prFormInfos'])
  },
  watch: {
    'params.unknown_store' (value) {
      if (value) this.$refs.store.clearSelection()
    }
  }
}
</script>
